import { render } from "./CadastroCompany.vue?vue&type=template&id=f9606154&scoped=true"
import script from "./CadastroCompany.vue?vue&type=script&lang=js"
export * from "./CadastroCompany.vue?vue&type=script&lang=js"

import "./CadastroCompany.vue?vue&type=style&index=0&id=f9606154&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9606154"]])

export default __exports__